<template>
  <svg width="22" height="22" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.1473 39.3684L1.47363 42.5264V4.63176L15.1473 1.47388L28.8524 4.63176L42.5262 1.47388V39.3684L28.8524 42.5264L15.1473 39.3684Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path d="M15.1709 1.47925V39.3774" stroke="currentColor" stroke-width="2" />
    <path d="M28.8291 4.63354V42.5156" stroke="currentColor" stroke-width="2" />
  </svg>
</template>
